// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1Mdph","errorLogs":"EditorFooter_errorLogs__37dhU"};